<template>
  <div v-if="personData" @keyup.enter="checkEmailRegistered" class="mt-6 p-lg-6 p-3">
    <h3 class="text-secondary font-weight-light text-center">{{ $t("common.welcome_screen.login_or_sign_up") }}</h3>
    <input
      :value="personData.email"
      @input="updateValues('email')"
      :placeholder="$t('common.welcome_screen.enter_email')"
      ref="emailInput"
      type="email"
      class="form-control"
      autofocus>
    <button
      @click="checkEmailRegistered"
      class="btn btn-sm btn-primary mt-2 float-right"
    >{{ $t("common.welcome_screen.continue") }}
      <i class="fe fe-arrow-right"></i>
    </button>

    <div class="mt-6 mb-4 text-center text-uppercase text-muted">
      <h4><i>or</i></h4>
    </div>
    <div class="text-center">

      <img class="mr-2" src="@/assets/static/main/google-logo-9808.png" width="25" height="25">
      <g-signin-button
        :params="googleSignInParams"
        @success="onSignInSuccess"
        @error="onSignInError">
        {{ $t("common.welcome_screen.continue_with_Google") }}
      </g-signin-button>
    </div>

    <div v-if="showInvite" class="dash-section p-3 mt-6">
      <p class="mt-2">You were invited to join "<b>{{showInvite.company_name}}</b>" by {{showInvite.created_by_first_name}} {{showInvite.created_by_last_name}}.
        {{ $t("common.welcome_screen.create_account_to_accept_invitation") }}</p>
    </div>
    <div class="p-3 mt-8 center">
      <language-switcher></language-switcher>
    </div>
  </div>
</template>

<script>
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';
  import { ValidateEmailMixin } from '../mixins/ValidateEmailMixin';
  import { checkEmail } from '../../../api/authApi';
  import languageSwitcher from '../../elements/languageSwitcher';

  export default {
    name: 'AuthStep',
    mixins: [AuthStepsMixin, ValidateEmailMixin],
    data () {
      return {
        googleSignInParams: {
          client_id: '87564396903-01ck5mpn8fkuchq19cfnlvvobm9vmnv9.apps.googleusercontent.com',
        },
      };
    },
    props: {
      showInvite: {
        default: function () {
          return null;
        },
      },
      personData: {
        default: function () {
          return null;
        },
      },
    },
    methods: {
      async checkEmailRegistered () {
        if (this.validateEmail(this.personData.email)) {
          const isRegistered = await checkEmail(this.personData.email);
          this.emitStep(isRegistered ? 'login' : 'signUp');
        } else {
          this.$noty.show('It looks like email is not a valid one');
        }
      },
      onSignInSuccess (googleUser) {
        const profile = googleUser.getBasicProfile();
        this.personData.email = profile.getEmail();
        this.checkEmailRegistered();
      },
      onSignInError () {
        this.$noty.error('Emika just had a trouble authorizing you with Google. Please, try again or sign up / sign in with your email instead.');
      },
    },
    components: {
      languageSwitcher,
    },
  };
</script>

<style scoped>

</style>
